module.exports = __webpack_public_path__ + "img/img13.8c68d26f.png";